import React, { useEffect, useState } from "react";

import {
  Subscribe,
  SubscribeSuccessPayload,
} from "@modules/Subscriptions/Flows/Subscribe/Subscribe";
import { useSearchParams } from "@Libs/Router/hooks/useSearchParams";
import { useLocation } from "@Libs/Router/hooks/useLocation";
import { useMetadata } from "@Libs/Events/hooks/useMetadata";
import { LoadingScreen } from "@UI/Components/LoadingScreen/LoadingScreen";
import { useNavigate } from "@Libs/Router/hooks/useNavigate";
import { useCurrentUser } from "@modules/Authentication/hooks/useCurrentUser";
import { ConfirmationModal } from "@modules/Subscriptions/Components/ConfirmationModal/ConfirmationModal";

export const GenericSubscriptionFlow = () => {
  const { queryParams } = useLocation();
  const navigate = useNavigate();
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [subscribeSuccessPayload, setSubscribeSuccessPayload] =
    useState<SubscribeSuccessPayload>(null);
  const returnUrl = useSearchParams("returnUrl");
  const context = useSearchParams("context");
  const { currentUser, isLoading } = useCurrentUser({
    includes: ["currentSubscription"],
  });

  const { setMetadata } = useMetadata();

  useEffect(() => {
    setMetadata({ context: context || "subscriptionFlow" });
  }, [context]);

  const handleLeave = async () => {
    if (returnUrl) {
      window.location.href = returnUrl;
    } else {
      navigate("ROOT", { reload: true });
    }
  };

  const handleSuccess = (payload: SubscribeSuccessPayload) => {
    setIsSuccessModalOpen(true);
    setSubscribeSuccessPayload(payload);
  };

  const isContextSet = context !== undefined;

  if (!isContextSet || isLoading) {
    return <LoadingScreen />;
  }

  if (currentUser?.currentSubscription) {
    navigate("MY_SUBSCRIPTION", { reload: true });
  }

  return (
    <>
      <Subscribe
        onLeave={handleLeave}
        rootRoute={{ to: ["SUBSCRIBE"], queryParams }}
        backRoute={{ to: ["ROOT"], queryParams }}
        onSuccess={handleSuccess}
      />
      <ConfirmationModal
        isOpen={isSuccessModalOpen}
        onConfirm={handleLeave}
        paymentMethod={subscribeSuccessPayload?.paymentMethod}
        isPaymentConfirmed={subscribeSuccessPayload?.isPaymentConfirmed}
      />
    </>
  );
};
